import OrderItem from '@/class/common/OrderItem';

/**
 * @description 工具方法
 * @author: 菩萨蛮
 * @date 2020/9/17 11:51 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

export const getVisible = (item, key, defaultValue) => {
  if (item === undefined) {
    return defaultValue;
  }
  if (item instanceof Object) {
    return item[key] !== undefined ? item[key] : defaultValue;
  }
  return item;
};

export const json2List = json => Object.keys(json).map(e => ({
  param: e,
  ...json[e]
}));

export const initObject = l => {
  const setValue = orderItemObj => {
    if (orderItemObj.defaultValue !== undefined) {
      return orderItemObj.defaultValue;
    }
    // type为其他时
    if (orderItemObj.type === 'boolean') {
      return false;
    }
    if (orderItemObj.type === 'array') {
      return [];
    }
    if (orderItemObj.type === 'time') {
      return null;
    }
    if (orderItemObj.type === 'object') {
      return {};
    }
    if (orderItemObj.type === undefined) {
      return '';
    }
    return null;
  };
  const getObj = list => {
    const obj = Object.create(null);
    list.forEach(e => {
      if (e.qxClassType === 'child') {
        const childList = json2List(e.qxJson);
        obj[e.param] = getObj(childList);
      } else {
        obj[e.param] = setValue(e);
      }
    });
    return obj;
  };
  return getObj(l);
};

export const list2baseItemObj = list => {
  const obj = Object.create(null);
  list.map(e => {
    obj[e.param] = new OrderItem({
      ...e,
      param: e.title
    });
    return null;
  });
  return obj;
};


export default {
  getVisible,
  json2List,
  initObject,
  list2baseItemObj
};
